export { default } from './Share';
export { default as adapter } from './adapter';
